import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IInitialState{
    selectedRadioBtn: string
}

const defaultRadioBtnState = 'hierarchical'

const initialState:IInitialState = {
    selectedRadioBtn: defaultRadioBtnState
}

const radioBtnSlice = createSlice({
    name: 'radioBtn',
    initialState,
    reducers:{
        setRadioBtn: ((state: IInitialState, action: PayloadAction<string>)=>{
            state.selectedRadioBtn = action.payload;
        }),

        resetRadioBtn: ((state: IInitialState)=>{
            state.selectedRadioBtn = defaultRadioBtnState
            
        })
    }
})

export default radioBtnSlice.reducer;
export const {setRadioBtn, resetRadioBtn} = radioBtnSlice.actions;